/* ═══════════════════════════════════════════════════════════════
   PureEthical — theme.js (lean orchestrator v2026)
   
   Standalone modules (loaded via layout):
     pe-utils.js        → PE.qs, PE.toast, PE.money, PE.trapFocus
     pe-cart.js         → cartAdd, cartChange, cartGet, renderCart, undo
     pe-product-card.js → wishlist, size hover, quick-add, pscroll drag
     pe-gallery.js      → gallery goTo, swipe, lightbox, colour swap
     pe-ui.js           → hero slider, scroll reveal, RV, header effects
   
   This file: product page ATC, variant logic, collection filters
   ═══════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {
'use strict';

/* ── PRODUCT PAGE ─────────────────────────────────────────────── */
/* ── PRODUCT PAGE ── */
var prodForm=qs('#ProductForm');
if(prodForm){
  var qtyVal=1;
  var qtyEl=qs('#prodQtyVal');
  var atcBtn=qs('#prodAtcBtn');
  var varSel=qs('#varSel');

  qs('#prodQtyMinus')&&qs('#prodQtyMinus').addEventListener('click',function(){
    if(qtyVal>1){qtyVal--;if(qtyEl)qtyEl.textContent=qtyVal;}
  });
  qs('#prodQtyPlus')&&qs('#prodQtyPlus').addEventListener('click',function(){
    qtyVal++;if(qtyEl)qtyEl.textContent=qtyVal;
  });

  /* Dynamic payment buttons bypass our ATC gate (they submit the form directly).
     v30 Fase 4: o "Comprar com Shop" fica SEMPRE visivel. Enquanto faltar escolher o tamanho/opcao,
     uma camada transparente por cima apanha o clique e pede o tamanho (igual ao botao Adicionar),
     e os botoes por baixo ficam inert (nem rato nem teclado chegam a eles). Assim nunca se compra
     um tamanho que o cliente nao escolheu. */
  function pickNeeded(){
    toast(window.PE_T('select_size','Please select a size'));
    var grid=qs('.gs-size-section')||qs('.gs-size-grid');
    if(grid){
      grid.scrollIntoView({behavior:'smooth',block:'center'});
      grid.classList.remove('sz-need-pick');
      void grid.offsetWidth; /* restart animation */
      grid.classList.add('sz-need-pick');
    }
  }
  function syncPaymentBtns(){
    var wrap=qs('.payment-btn-wrap');
    if(!wrap) return;
    var need={}, have={};
    qsa('.sz-btn').forEach(function(b){ need[b.dataset.opt]=true; });
    qsa('.sz-btn.on').forEach(function(b){ have[b.dataset.opt]=true; });
    var complete=true;
    for(var g in need){ if(!have[g]){ complete=false; break; } }
    wrap.style.display='';
    var gate=wrap.querySelector('.pe-pay-gate');
    if(!complete && !gate){
      if(getComputedStyle(wrap).position==='static') wrap.style.position='relative';
      gate=document.createElement('button');
      gate.type='button';
      gate.className='pe-pay-gate';
      gate.setAttribute('aria-label',window.PE_T('select_size','Please select a size'));
      gate.style.cssText='position:absolute;inset:0;z-index:5;width:100%;height:100%;margin:0;padding:0;border:0;background:transparent;cursor:pointer;';
      gate.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); pickNeeded(); });
      wrap.appendChild(gate);
    }
    if(gate) gate.hidden=complete;
    /* v30 F4: enquanto falta escolher, o Comprar com Shop aparece transparente (fica nitido ao escolher) */
    wrap.classList.toggle('pe-pay-locked',!complete);
    Array.prototype.forEach.call(wrap.children,function(c){
      if(c===gate) return;
      c.style.transition='opacity .2s ease';
      c.style.opacity=complete?'':'0.35';
    });
    Array.prototype.forEach.call(wrap.children,function(c){
      if(c===gate) return;
      if(complete){ c.removeAttribute('inert'); } else { c.setAttribute('inert',''); }
    });
  }
  syncPaymentBtns();
  /* o Shopify desenha os botoes de pagamento depois de o script correr: voltar a aplicar o inert */
  (function(){
    var wrap=qs('.payment-btn-wrap');
    if(!wrap||!window.MutationObserver) return;
    new MutationObserver(function(ms){
      for(var i=0;i<ms.length;i++){ if(ms[i].type==='childList'){ syncPaymentBtns(); break; } }
    }).observe(wrap,{childList:true});
  })();

  /* v30 Fase 4: fonte unica da variante escolhida (cor + tamanho).
     - So' ficam ativos os tamanhos que existem (e estao disponiveis) na cor escolhida; os outros
       aparecem riscados e nao se podem clicar. Antes, ex.: casaco Timberland Azul nao tem L - clicar em L
       deixava "Azul / S" no formulario com o L marcado, e voltar a uma cor podia deixar a cor anterior.
     - Se o tamanho marcado nao existir na nova cor, deixa de estar marcado (o cliente volta a escolher).
     - Sem tamanho marcado, o formulario fica na 1.a variante da cor (para o Comprar com Shop nao ficar
       desativado); o Adicionar e o Comprar com Shop continuam a exigir o tamanho (pickNeeded). */
  function pePartsOf(o){ return o.text.split(' / ').map(function(t){return t.trim();}); }
  /* v34: estado do botao Adicionar quando a cor escolhida esta esgotada */
  var peAtcOrig=atcBtn?atcBtn.textContent:'';
  function peAtcSoldOut(on){
    if(!atcBtn) return;
    if(on){ atcBtn.disabled=true; atcBtn.dataset.peSoldOut='1'; atcBtn.textContent=window.PE_T('sold_out','Sold out'); }
    else if(atcBtn.dataset.peSoldOut){ delete atcBtn.dataset.peSoldOut; atcBtn.disabled=false; atcBtn.textContent=peAtcOrig; }
  }
  function peResolve(){
    if(!varSel) { syncPaymentBtns(); return; }
    var szBtns=qsa('.sz-btn');
    var colThumb=qs('.gs-color-thumb.on');
    var colour=colThumb && colThumb.dataset.val ? String(colThumb.dataset.val).trim() : '';
    if(!szBtns.length){
      /* v34: produtos so com Cor - a variante e' a da cor marcada; cor esgotada = botao desativado */
      if(colour){
        var oc=[].slice.call(varSel.options).filter(function(o){ return o.value && pePartsOf(o).indexOf(colour)!==-1; });
        var pickO=oc.filter(function(o){return !o.disabled;})[0]||oc[0];
        if(pickO && varSel.value!==pickO.value){ varSel.value=pickO.value; if(atcBtn) atcBtn.dataset.vid=pickO.value; try{ varSel.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){} }
        peAtcSoldOut(!!(pickO && pickO.disabled));
      }
      syncPaymentBtns(); return;
    }
    var all=[].slice.call(varSel.options).filter(function(o){ return o.value && !o.disabled; });
    var forColour=colour ? all.filter(function(o){ return pePartsOf(o).indexOf(colour)!==-1; }) : all;
    if(colour && !forColour.length){
      /* v34: cor toda esgotada - antes reativava tamanhos de outras cores e ia outra cor para o cesto */
      szBtns.forEach(function(b){ b.disabled=true; b.classList.add('sz-sold-out'); b.classList.remove('on'); b.setAttribute('aria-disabled','true'); });
      peAtcSoldOut(true);
      syncPaymentBtns(); return;
    }
    peAtcSoldOut(false);
    if(!forColour.length) forColour=all;
    szBtns.forEach(function(b){
      var v=String(b.dataset.val).trim();
      var ok=forColour.some(function(o){ return pePartsOf(o).indexOf(v)!==-1; });
      b.disabled=!ok;
      b.classList.toggle('sz-sold-out',!ok);
      if(!ok) b.setAttribute('aria-disabled','true'); else b.removeAttribute('aria-disabled');
      if(!ok && b.classList.contains('on')){
        b.classList.remove('on');
        var lbl=qs('#optV-'+b.dataset.opt); if(lbl) lbl.textContent='';
      }
    });
    var onBtn=qs('.sz-btn.on');
    var target=null;
    if(onBtn){
      var sv=String(onBtn.dataset.val).trim();
      target=forColour.filter(function(o){ return pePartsOf(o).indexOf(sv)!==-1; })[0]||null;
    }
    if(!target) target=forColour[0]||null;
    if(target && varSel.value!==target.value){
      varSel.value=target.value;
      if(atcBtn) atcBtn.dataset.vid=target.value;
      try{ varSel.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){}
    }
    syncPaymentBtns();
  }
  /* v36 Fase 3AE: o URL acompanha a variante tambem quando so muda a cor. O clique na cor (mais abaixo,
     "Sync variant selector") muda o varSel sem o evento change, e o peResolve, ao encontrar o valor ja
     certo, tambem nao o dispara - o ?variant= ficava na variante anterior ate se escolher um tamanho.
     So corre depois de um clique numa cor (nunca no carregamento) e depois do peResolve, que so escolhe
     variantes disponiveis; usa replaceState, por isso nao cria entradas no historico. */
  function peSyncUrl(){
    if(!varSel || !varSel.value || !window.history || !history.replaceState) return;
    try{ var u=new URL(location.href); if(u.searchParams.get('variant')===varSel.value) return; u.searchParams.set('variant',varSel.value); history.replaceState(history.state,'',u.pathname+u.search+u.hash); }catch(e){}
  }
  /* a cor e' tratada por varios scripts (galeria, pe-colour-swap); corre no fim de todos */
  document.addEventListener('click',function(e){
    if(e.target && e.target.closest && e.target.closest('.gs-color-thumb')){
      setTimeout(function(){ peResolve(); peSyncUrl(); },0); setTimeout(function(){ peResolve(); peSyncUrl(); },180);
    }
  },false);
  peResolve();
  window.addEventListener('load',function(){ peResolve(); });
  /* v34: o URL acompanha a variante escolhida (links partilhados e Google Shopping abrem a cor certa) */
  if(varSel && window.history && history.replaceState){
    varSel.addEventListener('change',function(){
      try{ var u=new URL(location.href); u.searchParams.set('variant',varSel.value); history.replaceState(history.state,'',u.pathname+u.search+u.hash); }catch(e){}
    });
  }

  /* Size/option buttons */
  qsa('.sz-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var opt=btn.dataset.opt;
      qsa('.sz-btn[data-opt="'+opt+'"]').forEach(function(b){b.classList.remove('on');});
      btn.classList.add('on');
      var lbl=qs('#optV-'+opt);if(lbl)lbl.textContent=btn.dataset.label||btn.dataset.val;
      /* Match variant */
      if(varSel){
        var vals={};
        qsa('.sz-btn.on').forEach(function(b){vals[b.dataset.opt]=b.dataset.val;});
        /* v30 F4: a cor escolhida (bolinhas .gs-color-thumb) tambem conta. Antes so contava o tamanho e
           a variante caia na primeira cor com esse tamanho (ex.: Rosa + XL ia para o cesto como Preto / XL). */
        qsa('.gs-color-thumb.on').forEach(function(b){ if(b.dataset.opt&&b.dataset.val) vals[b.dataset.opt]=b.dataset.val; });
        var opts=varSel.options;
        for(var i=0;i<opts.length;i++){
          var o=opts[i],match=true;
          var parts=o.text.split(' / ').map(function(t){return t.trim();});for(var k in vals){if(parts.indexOf(String(vals[k]).trim())===-1){match=false;break;}} /* v27: comparacao exata (S != XS) */
          if(match){varSel.value=o.value;if(atcBtn)atcBtn.dataset.vid=o.value;try{varSel.dispatchEvent(new Event('change',{bubbles:true}));}catch(e){}break;} /* v30 F4: avisa o Comprar com Shop da variante escolhida */
        }
      }
      peResolve();
    });
  });

  /* ATC click — type=button avoids any Shopify form interference */
  if(atcBtn){
    atcBtn.addEventListener('click',function(){
      if(atcBtn.disabled)return;
      /* HARD GATE: every option group rendered as buttons must have an
         explicit selection before anything can be added. No group may be
         auto-resolved — a size the customer never chose must never ship. */
      var needGroups={}, haveGroups={};
      qsa('.sz-btn').forEach(function(b){ needGroups[b.dataset.opt]=true; });
      qsa('.sz-btn.on').forEach(function(b){ haveGroups[b.dataset.opt]=true; });
      var missing=null;
      for(var g in needGroups){ if(!haveGroups[g]){ missing=g; break; } }
      if(missing){ pickNeeded(); return; }
      var vid=varSel ? parseInt(varSel.value) : parseInt(atcBtn.dataset.vid);
      if(!vid||isNaN(vid)){toast(window.PE_T('select_size','Please select a size'));return;}
      atcBtn.disabled=true;
      var origText=atcBtn.textContent;
      atcBtn.textContent=window.PE_T('adding','Adding…');
      /* Always reset button after 2.5s max regardless of outcome */
      var safeReset=setTimeout(function(){
        atcBtn.disabled=false; atcBtn.textContent=origText;
      },2500);
      cartAdd(vid,qtyVal,
        function(){  /* success */
          clearTimeout(safeReset);
          atcBtn.disabled=false; atcBtn.textContent=origText;
          openCart(atcBtn); /* v30 Fase 1P: ao fechar o cesto o foco volta a este botao */
        },
        function(m){  /* error */
          clearTimeout(safeReset);
          atcBtn.disabled=false; atcBtn.textContent=origText;
          toast(m||window.PE_T('sold_out','Sold out')); /* v34: antes falhava em silencio */
        }
      );
    });
  }
}

/* ── PRODUCT GALLERY ── */
/* ═══════════════════════════════════════════════════
   PRODUCT GALLERY — Slider + Swipe + Thumbnails + Lightbox
   ═══════════════════════════════════════════════════ */

/* ── PRODUCT GALLERY — rebuilt: goTo, swipe, lightbox ── */
/* v42 auditoria B: bloco da galeria removido (procurava .gs-slide, que nao existe; a galeria e gerida por pe-gallery.js + pe-colour-swap.js) */


/* ── PRODUCT ACCORDIONS ── */
qsa('.accord-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    var body=btn.nextElementSibling;
    var open=btn.classList.toggle('open');
    if(body)body.classList.toggle('open',open);
  });
});


/* ── PRODUCT GALLERY ──────────────────────────────────────────── */
/* ── PRODUCT GALLERY — rebuilt: goTo, swipe, lightbox ── */
/* v42 auditoria B: duplicado identico do bloco acima - removido */



/* ── PRODUCT ACCORDIONS ───────────────────────────────────────── */
/* ── PRODUCT ACCORDIONS ── */
qsa('.accord-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    var body=btn.nextElementSibling;
    var open=btn.classList.toggle('open');
    if(body)body.classList.toggle('open',open);
  });
});


/* ── STOCK URGENCY + NOTIFY ME ───────────────────────────────── */
/* ── STOCK URGENCY + NOTIFY ME ── */
(function(){
  var urgencyEl  = qs('#stockUrgency');
  var urgencyMsg = qs('#stockUrgencyMsg');
  var notifyWrap = qs('#notifyWrap');
  var notifySize = qs('#notifySize');
  var notifyNote = qs('#notifyProductNote');
  if(!urgencyEl) return;

  function onSizeSelect(btn){
    var low   = btn.dataset.lowStock;
    var sold  = btn.dataset.soldOut === 'true';
    var val   = btn.dataset.val || '';

    /* Stock urgency */
    if(low && !sold){
      urgencyMsg.textContent = window.PE_T('only_left_size','Only {n} left in this size — order soon!').replace('{n}', low);
      urgencyEl.style.display = 'flex';
    } else {
      urgencyEl.style.display = 'none';
    }

    /* Notify Me */
    if(sold){
      if(notifySize) notifySize.textContent = val;
      if(notifyNote) notifyNote.value = (document.querySelector('.pi-title')||{}).textContent + ' — ' + val;
      if(notifyWrap) notifyWrap.style.display = 'block';
    } else {
      if(notifyWrap) notifyWrap.style.display = 'none';
    }
  }

  document.querySelectorAll('.sz-btn').forEach(function(btn){
    btn.addEventListener('click', function(){ onSizeSelect(btn); });
  });
  /* Trigger for first selected */
  var first = document.querySelector('.sz-btn.on');
  if(first) onSizeSelect(first);
})();


/* ── COLOUR SWATCHES (product page data) ─────────────────────── */
/* ── GYMSHARK COLOUR SWATCHES — gallery swap ── */
(function(){
  var thumbs = document.querySelectorAll('.gs-color-thumb');
  if(!thumbs.length) return;

  function swapGallery(images, zooms){
    /* images: array of src URLs, zooms: array of high-res URLs */
    var grid = document.getElementById('galSlider');
    if(!grid) return;

    /* Remove existing items */
    grid.innerHTML = '';

    if(!images || images.length === 0) return;

    images.forEach(function(src, i){
      var zoom = zooms[i] || src;
      var item = document.createElement('div');
      item.className = 'gs-img-item';
      item.dataset.index = i;

      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.dataset.zoom = zoom;
      img.draggable = false;

      var hint = document.createElement('button');
      hint.className = 'gs-zoom-hint';
      hint.setAttribute('aria-label', 'Zoom');
      hint.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';

      item.appendChild(img);
      item.appendChild(hint);
      grid.appendChild(item);

      /* Lightbox click */
      item.addEventListener('click', function(){
        openLbFromItem(item, i, images, zooms);
      });
      hint.addEventListener('click', function(e){
        e.stopPropagation();
        openLbFromItem(item, i, images, zooms);
      });
    });

    /* Re-init intersection observer for dots */
    var dots = document.querySelectorAll('.gal-dot');
    if(dots.length && window.IntersectionObserver){
      var items = grid.querySelectorAll('.gs-img-item');
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            var idx = Array.from(items).indexOf(en.target);
            dots.forEach(function(d,di){ d.classList.toggle('on', di===idx); });
          }
        });
      },{threshold:.5});
      items.forEach(function(it){ io.observe(it); });
    }
  }

  /* Lightweight lightbox opener for swapped images */
  function openLbFromItem(item, idx, images, zooms){
    var lb = document.getElementById('galLightbox');
    var lbImg = document.getElementById('galLbImg');
    var lbCtr = document.getElementById('galLbCounter');
    if(!lb || !lbImg) return;

    var curIdx = idx;
    var showLb = function(i){
      lbImg.style.opacity = '0';
      lbImg.src = zooms[i] || images[i];
      lbImg.onload = function(){ lbImg.style.opacity = '1'; };
      if(lbCtr) lbCtr.textContent = (i+1) + ' / ' + images.length;
      curIdx = i;
    };

    showLb(idx);

    /* Scroll lock */
    var sy = window.pageYOffset;
    document.body.style.cssText = 'position:fixed;top:-'+sy+'px;left:0;right:0;overflow:hidden;';

    lb.style.display = 'block';
    requestAnimationFrame(function(){ lb.classList.add('lb-open'); });

    var closeLb = function(){
      lb.classList.remove('lb-open');
      setTimeout(function(){
        lb.style.display = 'none';
        document.body.style.cssText = '';
        window.scrollTo(0, sy);
      }, 150);
    };

    /* Close / nav */
    var lbClose = document.getElementById('galLbClose');
    var lbPrev  = document.getElementById('galLbPrev');
    var lbNext  = document.getElementById('galLbNext');

    var _close = function(e){ e.stopPropagation(); closeLb(); };
    var _prev  = function(e){ e.stopPropagation(); showLb((curIdx-1+images.length)%images.length); };
    var _next  = function(e){ e.stopPropagation(); showLb((curIdx+1)%images.length); };

    if(lbClose){ lbClose.onclick = _close; }
    if(lbPrev)  { lbPrev.onclick  = _prev; }
    if(lbNext)  { lbNext.onclick  = _next; }
    lb.onclick = function(e){
      if(!e.target.closest('#galLbPrev,#galLbNext,#galLbClose,#galLbImgWrap')) closeLb();
    };
  }

  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var opt = thumb.dataset.opt;
      var val = thumb.dataset.val;
      var rawImages = thumb.dataset.images || '';
      var rawZooms  = thumb.dataset.zoom   || '';

      /* Update active state */
      document.querySelectorAll('.gs-color-thumb[data-opt="'+opt+'"]').forEach(function(t){
        t.classList.remove('on');
      });
      thumb.classList.add('on');

      /* Update colour name */
      var nameEl = document.querySelector('.gs-color-name');
      if(nameEl) nameEl.textContent = thumb.dataset.label || val;

      /* Parse images (split by |||) */
      var images = rawImages.split('|||').filter(Boolean);
      var zooms  = rawZooms.split('|||').filter(Boolean);

      /* Swap gallery if we have images for this colour */
      /* v42 auditoria B: as fotos da cor sao trocadas so' pelo pe-colour-swap.js (antes a galeria era reconstruida 4-5 vezes) */

      /* Sync variant selector */
      var varSel = document.getElementById('varSel');
      if(varSel){
        var allVals = {};
        document.querySelectorAll('.sz-btn.on[data-opt]').forEach(function(b){
          allVals[b.dataset.opt] = b.dataset.val;
        });
        allVals[opt] = val;
        var opts = varSel.options;
        for(var i=0;i<opts.length;i++){
          var o=opts[i], match=true;
          var parts=o.text.split(' / ').map(function(t){return t.trim();});for(var k in allVals){if(parts.indexOf(String(allVals[k]).trim())===-1){match=false;break;}} /* v27: comparacao exata */
          if(match){
            varSel.value = o.value;
            var ab = document.getElementById('prodAtcBtn');
            if(ab) ab.dataset.vid = o.value;
            break;
          }
        }
      }
    });
  });
})();



/* ── VARIANT IMAGE CHANGE ─────────────────────────────────────── */
/* ── VARIANT IMAGE CHANGE ── */
(function(){
  var galMain = qs('#galMain');
  if(!galMain) return;
  var mainImg = galMain.querySelector('img');
  if(!mainImg) return;

  // When colour swatch changes, update main image
  document.addEventListener('click', function(e){
    var swatch = e.target.closest('.color-swatch');
    if(!swatch) return;
    var val = swatch.dataset.val;
    if(!val) return;
    // Find variant with matching option
    var varSel = qs('#varSel');
    if(!varSel) return;
    var opts = varSel.options;
    for(var i=0;i<opts.length;i++){
      if(opts[i].text.toLowerCase().includes(val.toLowerCase())){
        var vid = opts[i].value;
        // Fetch variant image from Shopify
        fetch('/products/' + document.body.dataset.productHandle + '.js')
          .then(function(r){ return r.json(); })
          .then(function(p){
            var variant = p.variants.find(function(v){ return String(v.id) === String(vid); });
            if(variant && variant.featured_image){
              var newSrc = variant.featured_image.src.replace(/(\.\w+)(\?|$)/, '_800x$1$2');
              mainImg.src = newSrc;
            }
          }).catch(function(){});
        break;
      }
    }
  });
})();


/* ── COPY LINK BUTTON ─────────────────────────────────────────── */
/* ── COPY LINK BUTTON ── */
(function(){
  var copyBtn = qs('#copyLink');
  if(!copyBtn) return;
  copyBtn.addEventListener('click', function(){
    navigator.clipboard.writeText(window.location.href).then(function(){
      copyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>';
      setTimeout(function(){
        copyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>';
      }, 2000);
    });
  });
})();


/* ── COLLECTION FILTER ────────────────────────────────────────── */
/* ── MOBILE SIDEBAR FILTER ── */
var sbTrigger=qs('#sbTrigger');
var collSidebar=qs('#collSidebar');
var sbOverlay=qs('#sbOverlay');
var sbClose=qs('#sbClose');
function openSidebar(){
  if(collSidebar)collSidebar.classList.add('open');
  /* Only show overlay on mobile */
  if(sbOverlay && window.innerWidth < 769) sbOverlay.classList.add('open');
  if(window.innerWidth < 769) lock();
  try{sessionStorage.setItem('pe_sidebar','1');}catch(e){}
}
function closeSidebar(){
  if(collSidebar)collSidebar.classList.remove('open');
  if(sbOverlay)sbOverlay.classList.remove('open');
  unlock();
  try{sessionStorage.removeItem('pe_sidebar');}catch(e){}
}
if(sbTrigger)sbTrigger.addEventListener('click',openSidebar);
if(sbClose)sbClose.addEventListener('click',closeSidebar);
if(sbOverlay)sbOverlay.addEventListener('click',closeSidebar);

/* Re-open sidebar after navigation */
try{
  if(sessionStorage.getItem('pe_sidebar')==='1') openSidebar();
}catch(e){}


/* Filter handled in collection-page.liquid inline script */


/* ── SORT SELECT ── */
var sortSel=qs('#sortSel');
if(sortSel)sortSel.addEventListener('change',function(){location.href=this.value;});

qsa('input[name="sort_by"]').forEach(function(r){
  r.addEventListener('change',function(){if(this.dataset.url)location.href=this.dataset.url;});
});

/* ── PRICE FILTER ── */
var priceApply=qs('#priceApply');
if(priceApply){
  priceApply.addEventListener('click',function(){
    var min=qs('#priceMin').value;
    var max=qs('#priceMax').value;
    var url=new URL(location.href);
    if(min)url.searchParams.set('filter.v.price.gte',min);
    else url.searchParams.delete('filter.v.price.gte');
    if(max)url.searchParams.set('filter.v.price.lte',max);
    else url.searchParams.delete('filter.v.price.lte');
    location.href=url.toString();
  });
}


/* ── ACTIVE FILTER PILLS ──────────────────────────────────────── */
/* ── ACTIVE FILTER PILLS ── */
(function(){
  var container = qs('#activeFilters');
  if(!container) return;

  function updatePills(){
    var params = new URLSearchParams(window.location.search);
    var pills = [];
    params.forEach(function(val, key){
      if(key.startsWith('filter.') || key === 'sort_by'){
        var label = key === 'sort_by' ? window.PE_T('sort_prefix','Sort: ')+val : val;
        pills.push({key:key, val:val, label:label});
      }
    });
    if(pills.length === 0){ container.style.display='none'; return; }
    container.style.display='flex';
    container.innerHTML = pills.map(function(p){
      var esc=function(v){return String(v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}; /* v27: valores vem do URL */
      return '<button class="filter-pill" data-key="'+esc(p.key)+'" data-val="'+esc(p.val)+'">'+esc(p.label)+' <span class="filter-pill-x">×</span></button>';
    }).join('');
  }

  container.addEventListener('click', function(e){
    var pill = e.target.closest('.filter-pill');
    if(!pill) return;
    var params = new URLSearchParams(window.location.search);
    params.delete(pill.dataset.key);
    window.location.search = params.toString();
  });

  updatePills();
})();


/* ── MOBILE NAV ACCORDIONS ───────────────────────────────────── */
/* ── MOBILE NAV ACCORDIONS ── */
qsa('.mn-accord-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    var body=btn.nextElementSibling;
    var isOpen=btn.classList.contains('open');
    // Close ALL accordions in this panel
    var panel=btn.closest('.mn-panel')||btn.closest('.mn-accord')?.parentElement;
    var allBtns=panel?panel.querySelectorAll('.mn-accord-btn'):qsa('.mn-accord-btn');
    allBtns.forEach(function(b){
      b.classList.remove('open');
      var bd=b.nextElementSibling;
      if(bd&&bd.classList.contains('mn-accord-body'))bd.classList.remove('open');
    });
    // Open clicked one only if it was closed
    if(!isOpen){
      btn.classList.add('open');
      if(body)body.classList.add('open');
    }
  });
});


/* ── LANGUAGE PICKER ─────────────────────────────────────────── */
/* ── LANGUAGE PICKER ── */
(function(){
  var btn = document.getElementById('langBtn');
  var drop = document.getElementById('langDrop');
  if(!btn || !drop) return;
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    drop.classList.toggle('open');
  });
  document.addEventListener('click', function(){
    drop.classList.remove('open');
  });
})();



}); /* end DOMContentLoaded */
